<template>
  <tr>
    <th></th>
    <th></th>
    <th></th>
    <th class="text-center">
      <div><b>Total Net Income</b></div>
    </th>
    <th></th>
    <th></th>
    <td class="text-center">
      <div>
        {{ totalNetPrice + " ฿" }}
      </div>
    </td>
    <th></th>
    <th></th>
  </tr>
</template>

<script>
export default {
  name: "totalSalesStoreNet",
  props: ["totalNetPrice"],
};
</script>

<style>
</style>